var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isExternal(_vm.to))?_c('a',{attrs:{"href":_vm.to,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.name))]):_c('a',{class:_vm.name === _vm.$route.meta.parentName ? 'active' : '',on:{"click":function($event){return _vm.goto(_vm.to)}}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }